import React, { useEffect, useMemo, useRef, useState } from 'react'
// import { useNavigate, useParams } from 'react-router-dom'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { FrontApi } from '../../../api/front-api/front.api';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { RootState } from '../../../store/store';
import { ImageContent } from '../../../assets/background/background';
import clsx from 'clsx'
import { BANNER_TYPE } from '../../cms-website/website-structure/content/enum/content.enum';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import ContainerButton from '../../../components/button/ContainerButton';
import HtmlRenderer from '../../../components/render-html/RenderHtml';
import TagCustom from '../../../components/tag/TagCustom';
import { OptionContent } from '../../../components/option-content/option_content';
import SharedContent from '../../../components/shared/SharedContent';
import { decodeId, shareToFacebook, shareToLine, shareToX } from '../../../utils/app.utils';
import { likeContent, SOCIAL_MEDIA_TYPE } from '../../../utils/global.func';
import PreviewImage from '../../../components/preview-image/PreviewImage';
import he from 'he'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { colors } from '../../../constants/colors';
import { useTranslation } from 'react-i18next';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';



type Props = {}
const chunkArray = (array: any[], size: number) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
        array.slice(index * size, index * size + size)
    );
};

const PressReleaseDetail: React.FC<Props> = ({ }: Props) => {
    const { id_content } = useParams();
    const { t } = useTranslation();
    const id = decodeId(id_content || "")
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const mode = theme.palette.mode;
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    const baseApi = useSelector((state: RootState) => state.api.image_api);
    const baseApi_content = useSelector((state: RootState) => state.api.public_content_api);
    const current_path = location.pathname

    // const matches = useMediaQuery(theme.breakpoints.down('lg'));
    // const nextRef = useRef<HTMLDivElement>(null);
    // const preRef = useRef<HTMLDivElement>(null);


    const [warning_detail, set_warning_detail] = useState<any>(null);
    const [banner_type, _set_banner_type] = useState<string>(BANNER_TYPE.TYPE_THREE);
    const [media_file, set_media_file] = useState<any[]>([]);
    // const [comment_text, set_comment_text] = useState<string>("");

    const [content_recommend, set_content_recommend] = useState<any[]>([]);
    const [comment, set_comment] = useState<any[]>([]);
    // const [is_show_all_comment, set_is_show_all_comment] = useState<boolean>(false);

    // const [open_alert, set_open_alert] = React.useState(false);

    // const handleAlert = () => {
    //     set_open_alert(true);
    // };

    function htmlToText(html: string): string {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    }

    const handleGetData = async (id_content: number) => {
        dispatch(setLoading());
        await FrontApi.findOneContent(id_content).then((res) => {
            if (res.status < 300) {
                set_warning_detail(res.data?.data || null)
                // set_banner_type(res.data?.data?.banner_type || "");
                const media_file: any[] = Array.isArray(res.data?.data?.content_files) ? res.data?.data?.content_files : [];
                const mapDataFile = media_file?.map((list) => {
                    return {
                        ...list,
                        ...list?.media_file
                    }
                })
                const comment_data = res.data?.data?.comment || [];
                // const related_contents: any[] = res.data?.data?.related_contents || [];
                // set_content_recommend(related_contents);
                set_comment(comment_data);
                set_media_file(mapDataFile);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetContentRecommend = async () => {
        await FrontApi.news({ page: 1, limit: 5, }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_content_recommend(response)
                console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const isHTMLString = (str: string): boolean => {
        const htmlRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlRegex.test(str);
    }
    // ตัวอย่างการใช้งาน
    const isHTML = isHTMLString(warning_detail?.content_name ?? '');


    useEffect(() => {
        handleGetContentRecommend();
    }, [])
    useEffect(() => {
        window.scrollTo({ top: 2, behavior: 'smooth' })
        if (!id) {
            navigate('/404');
        } else {
            handleGetData(id)
        }
    }, [id]);

    const raw_article_desc = he.decode(warning_detail?.content_detail || "");


    const chunks: any[] = chunkArray(media_file?.length > 0 ? media_file : [], 4);
    const content_path: string = `${baseApi_content}${current_path}`
    // const debouncedSetText = useMemo(() => debounce(set_comment_text, 200), []);
    // const debouncedSetSticker = useMemo(() => debounce(set_comment_text, 400), []);


    return (
        <>
            <Box sx={{
                backgroundColor: mode === 'dark' ? "black" : "white"
            }} component={'main'} className='w-full py-8 px-4 pt-4 md:px-[100px] md:py-3 overflow-hidden'>
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "WARNING_NEWS",
                            name: t("HOME_PAGE_PRESS_RELEASE"),
                            pathName: routeName.main.pressRelease
                        },
                        {
                            key: "WARNING_NEWS_DETAIL",
                            name: isHTML ? htmlToText(warning_detail?.content_name) : warning_detail?.content_name || "-",
                            pathName: current_path
                        }
                    ]}
                />
                {(chunks?.length !== 0 && banner_type !== BANNER_TYPE.TYPE_THREE) && (
                    <>
                        <section className='w-full h-full pt-8'>
                            <div className={clsx('grid grid-cols-12 gap-4 h-full lg:h-fit overflow-hidden', {
                                'hidden': banner_type === BANNER_TYPE.TYPE_FOUR || banner_type === BANNER_TYPE.TYPE_THREE || banner_type === BANNER_TYPE.TYPE_TWO,
                            })}>
                                <Box component={'span'} data-aos="fade-right"
                                    data-aos-offset="0"
                                    data-aos-easing="ease-in-sine"
                                    data-aos-anchor-placement="top-bottom"
                                    className={clsx('h-full max-h-[500px] shadow-md rounded-2xl overflow-hidden', {
                                        'col-span-12 md:col-span-12 lg:col-span-6': banner_type === BANNER_TYPE.TYPE_TWO,
                                        // 'col-span-12 md:col-span-12 lg:col-span-8': banner_type === BANNER_TYPE.TYPE_THREE,
                                        'col-span-12': banner_type === BANNER_TYPE.TYPE_ONE,
                                    })}>
                                    {banner_type !== BANNER_TYPE.TYPE_ONE && (
                                        <>
                                            {media_file?.length > 0 ? (
                                                <PreviewImage
                                                    image_url={`${baseApi}/${media_file[0]?.media_file_path}${media_file[0]?.media_file_name}`}
                                                    disable_show={false}
                                                    disabled_max_width
                                                    render_image={
                                                        <img className='w-full h-full object-cover' src={`${baseApi}/${media_file[0]?.media_file_path}${media_file[0]?.media_file_name}`} alt="image" />

                                                    }
                                                />
                                            ) : (
                                                <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                            )}
                                        </>
                                    )}
                                    {banner_type === BANNER_TYPE.TYPE_ONE && media_file?.length > 0 ? (
                                        <Swiper
                                            spaceBetween={30}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            modules={[Pagination]}
                                            className="type_one"
                                        >
                                            {media_file?.map((list, index) => {
                                                return (
                                                    <SwiperSlide key={list?.id_content}>
                                                        <PreviewImage
                                                            image_url={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                            disable_show={false}
                                                            disabled_max_width
                                                            render_image={
                                                                <img
                                                                    className='w-full cursor-grab h-full object-cover'
                                                                    src={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                                    alt={`image_${index}`}
                                                                />
                                                            }
                                                        />
                                                    </SwiperSlide>
                                                )
                                            })}
                                        </Swiper>
                                    ) : (
                                        <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                    )}
                                </Box>
                                <Box component={'span'} data-aos="fade-right"
                                    data-aos-offset="0"
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-easing="ease-in-sine"
                                    className={clsx('h-full max-h-[500px] rounded-2xl overflow-hidden', {
                                        'col-span-12 md:col-span-12 lg:col-span-3 ': banner_type === BANNER_TYPE.TYPE_TWO,
                                        'hidden': banner_type === BANNER_TYPE.TYPE_THREE || banner_type === BANNER_TYPE.TYPE_ONE,
                                    })}>
                                    {media_file?.length > 1 ? (
                                        <PreviewImage
                                            image_url={`${baseApi}/${media_file[1]?.media_file_path}${media_file[1]?.media_file_name}`}
                                            disable_show={false}
                                            disabled_max_width
                                            render_image={
                                                <img className='w-full h-full object-cover' src={`${baseApi}/${media_file[1]?.media_file_path}${media_file[1]?.media_file_name}`} alt="image" />
                                            }
                                        />
                                    ) : (
                                        <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                    )}
                                </Box>
                                <Box component={'span'} data-aos="fade-down"
                                    data-aos-easing="linear"
                                    data-aos-offset="0"
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-duration="600" className={clsx('h-full  max-h-[500px] flex flex-row lg:flex-col ', {
                                        'col-span-12 gap-4 md:col-span-12 lg:col-span-3': banner_type === BANNER_TYPE.TYPE_TWO,
                                        'col-span-12 gap-4 md:col-span-12 lg:col-span-4': banner_type === BANNER_TYPE.TYPE_THREE,
                                        'hidden': banner_type === BANNER_TYPE.TYPE_ONE,
                                    })}>
                                    <div className={clsx('w-full h-full rounded-2xl overflow-hidden', {
                                    })}>
                                        {media_file?.length > 2 ? (
                                            <PreviewImage
                                                image_url={`${baseApi}/${media_file[2]?.media_file_path}${media_file[2]?.media_file_name}`}
                                                disable_show={false}
                                                disabled_max_width
                                                render_image={
                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${media_file[2]?.media_file_path}${media_file[2]?.media_file_name}`} alt="image" />
                                                }
                                            />
                                        ) : (
                                            <img className={clsx('w-full h-full object-cover')} src={ImageContent.noImage} alt="noImage" />
                                        )}
                                    </div>
                                    <div className='w-full h-full rounded-2xl overflow-hidden'>
                                        {media_file?.length > 3 ? (
                                            <PreviewImage
                                                image_url={`${baseApi}/${media_file[3]?.media_file_path}${media_file[3]?.media_file_name}`}
                                                disable_show={false}
                                                disabled_max_width
                                                render_image={
                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${media_file[3]?.media_file_path}${media_file[3]?.media_file_name}`} alt="image" />
                                                }
                                            />
                                        ) : (
                                            <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                        )}
                                    </div>
                                    {/* {banner_type === BANNER_TYPE.TYPE_THREE && (
                                        <>
                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                {media_file?.length > 4 ? (
                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${media_file[4]?.media_file_path}${media_file[4]?.media_file_name}`} alt="image" />
                                                ) : (
                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                )}
                                            </div>
                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                {media_file?.length > 5 ? (
                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${media_file[5]?.media_file_path}${media_file[5]?.media_file_name}`} alt="image" />
                                                ) : (
                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                )}
                                            </div>
                                        </>
                                    )} */}
                                </Box>
                            </div>
                        </section>

                        {/* TYPE 2 AND 3 */}
                        <section className='w-full h-full pt-8'>
                            <Swiper
                                spaceBetween={30}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Pagination]}
                                className="type_one"
                                autoplay={{
                                    delay: 1000
                                }}
                            >
                                {chunks?.length > 0 && chunks?.map((chunk: any, main_index) => {
                                    return (
                                        <SwiperSlide key={main_index}>
                                            <div className={clsx('grid grid-cols-12 gap-4 h-full lg:h-fit overflow-hidden', {
                                                'hidden': !(banner_type === BANNER_TYPE.TYPE_TWO || banner_type === BANNER_TYPE.TYPE_THREE),
                                            })}>

                                                <React.Fragment>
                                                    <Box component={'span'} data-aos="fade-right"
                                                        data-aos-offset="จ"
                                                        data-aos-easing="ease-in-sine"
                                                        data-aos-anchor-placement="top-bottom"
                                                        className={clsx('h-full max-h-[500px] shadow-md rounded-2xl overflow-hidden', {
                                                            'col-span-12 md:col-span-12 lg:col-span-6': banner_type === BANNER_TYPE.TYPE_TWO,
                                                            'col-span-12 md:col-span-12 lg:col-span-8': banner_type === BANNER_TYPE.TYPE_THREE,
                                                        })}>
                                                        {chunk[0]?.media_file_path ? (
                                                            <PreviewImage
                                                                image_url={`${baseApi}/${chunk[0]?.media_file_path}${chunk[0]?.media_file_name}`}
                                                                disable_show={false}
                                                                disabled_max_width
                                                                render_image={
                                                                    <img className='w-full h-full object-cover'
                                                                        src={`${baseApi}/${chunk[0]?.media_file_path}${chunk[0]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                }
                                                            />
                                                        ) : (
                                                            <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                        )}
                                                    </Box>
                                                    <Box component={'span'} data-aos="fade-right"
                                                        data-aos-offset="จ"
                                                        data-aos-anchor-placement="top-bottom"
                                                        data-aos-easing="ease-in-sine"
                                                        className={clsx('h-full max-h-[500px] rounded-2xl overflow-hidden', {
                                                            'col-span-12 md:col-span-12 lg:col-span-3 ': banner_type === BANNER_TYPE.TYPE_TWO,
                                                            'hidden': banner_type === BANNER_TYPE.TYPE_THREE,
                                                        })}>
                                                        {chunk[1]?.media_file_path ? (
                                                            <PreviewImage
                                                                image_url={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                disable_show={false}
                                                                disabled_max_width
                                                                render_image={
                                                                    <img className='w-full h-full object-cover'
                                                                        src={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                }
                                                            />

                                                        ) : (
                                                            <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                        )}
                                                    </Box>
                                                    <Box component={'span'} data-aos="fade-down"
                                                        data-aos-easing="linear"
                                                        data-aos-offset="0"
                                                        data-aos-anchor-placement="top-bottom"
                                                        data-aos-duration="600" className={clsx('h-full  max-h-[500px] flex flex-row lg:flex-col ', {
                                                            'col-span-12 gap-4 md:col-span-12 lg:col-span-3': banner_type === BANNER_TYPE.TYPE_TWO,
                                                            'col-span-12 gap-4 md:col-span-12 lg:col-span-4': banner_type === BANNER_TYPE.TYPE_THREE,
                                                            'hidden': banner_type === BANNER_TYPE.TYPE_ONE || banner_type === BANNER_TYPE.TYPE_THREE,
                                                        })}>
                                                        <div className={clsx('w-full h-full rounded-2xl overflow-hidden', {
                                                        })}>
                                                            {chunk[2]?.media_file_path ? (
                                                                <PreviewImage
                                                                    image_url={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                    disable_show={false}
                                                                    disabled_max_width
                                                                    render_image={
                                                                        <img className='w-full h-full object-cover'
                                                                            src={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                            alt="image" />
                                                                    }
                                                                />

                                                            ) : (
                                                                <img className={clsx('w-full h-full object-cover')} src={ImageContent.noImage} alt="noImage" />
                                                            )}
                                                        </div>
                                                        <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                            {chunk[3]?.media_file_path ? (
                                                                <PreviewImage
                                                                    image_url={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                    disable_show={false}
                                                                    disabled_max_width
                                                                    render_image={
                                                                        <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                            alt="image"
                                                                        />
                                                                    }
                                                                />

                                                            ) : (
                                                                <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                            )}
                                                        </div>
                                                    </Box>
                                                    {/* {banner_type === BANNER_TYPE.TYPE_THREE && (
                                                        <Box component={'span'} data-aos="fade-down"
                                                            data-aos-easing="linear"
                                                            data-aos-offset="0"
                                                            data-aos-anchor-placement="top-bottom"
                                                            data-aos-duration="600" className={clsx('h-full  max-h-[500px] flex flex-row lg:flex-col ', {
                                                                'col-span-12 gap-4 md:col-span-12 lg:col-span-4': banner_type === BANNER_TYPE.TYPE_THREE,
                                                            })}>
                                                            <div className={clsx('w-full h-full rounded-2xl overflow-hidden', {
                                                            })}>
                                                                {chunk[1]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover'
                                                                        src={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                        alt="image" />
                                                                ) : (
                                                                    <img className={clsx('w-full h-full object-cover')} src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                                {chunk[2]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                                {chunk[3]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                                {chunk[4]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[4]?.media_file_path}${chunk[4]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                        </Box>
                                                    )} */}

                                                </React.Fragment>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })}
                            </Swiper>
                        </section>
                    </>
                )}

                <section className='grid grid-cols-12 gap-8'>
                    <article className={clsx('col-span-12 ', {
                        'md:col-span-8': banner_type === BANNER_TYPE.TYPE_THREE
                    })}>
                        <section className='w-full pt-4 md:pt-10 flex flex-col gap-2'>
                            {isHTML ? (
                                <HtmlRenderer html={warning_detail?.content_name} />
                            ) : (
                                <Typography sx={{
                                    color: (theme) => theme.palette.text.primary,
                                }} variant='h4'>
                                    {warning_detail?.content_name || "-"}
                                </Typography>
                            )}
                            <article className='flex justify-between items-center'>
                                <Box className="w-full">
                                    <OptionContent
                                        date_row
                                        date={warning_detail?.content_start_date || ""}
                                        count={{
                                            onLikeClick: () => likeContent(warning_detail?.id_content, +warning_detail?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (_, id, type) => {
                                                set_warning_detail((prev: any) => ({
                                                    ...prev,
                                                    total_like: type === 'LIKE' ? +prev?.total_like + 1 : +prev?.total_like - 1,
                                                    is_like: type === 'LIKE' ? true : false
                                                }))
                                            }),
                                            view: +warning_detail?.total_view || 0,
                                            like: +warning_detail?.total_like || 0,
                                            like_checked: +warning_detail?.is_like ? true : false,
                                            shared: +warning_detail?.total_shared || 0,
                                            onSharedClick: {
                                                facebookClick: () => {
                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                        set_warning_detail((prev: any) => ({
                                                            ...prev,
                                                            total_shared: st ? +prev?.total_shared + 1 : +prev?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                    shareToFacebook(content_path)
                                                },
                                                lineClick: () => {
                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                        set_warning_detail((prev: any) => ({
                                                            ...prev,
                                                            total_shared: st ? +prev?.total_shared + 1 : +prev?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.LINE)
                                                    shareToLine(content_path, warning_detail?.content_name)
                                                },
                                                xClick: () => {
                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                        set_warning_detail((prev: any) => ({
                                                            ...prev,
                                                            total_shared: st ? +prev?.total_shared + 1 : +prev?.total_shared
                                                        }))
                                                    }, SOCIAL_MEDIA_TYPE.X)
                                                    shareToX(content_path, warning_detail?.content_name)
                                                },
                                            }
                                        }}
                                    />
                                </Box>
                                <span className={clsx('', {
                                    'w-full max-w-fit flex justify-end items-center': banner_type === BANNER_TYPE.TYPE_THREE
                                })}>
                                    <SharedContent
                                        copy={content_path}
                                        facebook_link={content_path}
                                        line_link={content_path}
                                        textLine={warning_detail?.content_name || ""}
                                        textX={warning_detail?.content_name || ""}
                                        x_link={content_path}
                                        callback_facebook_click={() => {
                                            likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                set_warning_detail((prev: any) => ({
                                                    ...prev,
                                                    total_shared: st ? +prev?.total_shared + 1 : +prev?.total_shared
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                        }}
                                        callback_line_click={() => {
                                            likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                set_warning_detail((prev: any) => ({
                                                    ...prev,
                                                    total_shared: st ? +prev?.total_shared + 1 : +prev?.total_shared
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.LINE)
                                        }}
                                        callback_x_click={() => {
                                            likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                set_warning_detail((prev: any) => ({
                                                    ...prev,
                                                    total_shared: st ? +prev?.total_shared + 1 : +prev?.total_shared
                                                }))
                                            }, SOCIAL_MEDIA_TYPE.X)
                                        }}
                                    />
                                </span>
                            </article>
                        </section>

                        <section className={
                            clsx('w-full flex flex-col my-10 px-4')
                        }>
                            <HtmlRenderer html={raw_article_desc} />
                        </section>

                        {/* <div className='w-full flex flex-col gap-2'>
                            <Typography sx={{
                                color: (theme) => theme.palette.text.primary,
                            }}>
                                ชนิดสินค้า : {warning_detail?.content_item?.length > 0 ? warning_detail?.content_item?.map((x: any) => x?.item_name).join(", ") : "-"}
                            </Typography>
                            <Typography sx={{
                                color: (theme) => theme.palette.text.primary,
                            }}>
                                ประเภทของข่าว : {warning_detail?.content_category?.length > 0 && warning_detail?.content_category?.map((list: any) => `${list?.category_name}`).join(", ")}
                            </Typography>
                            <Typography sx={{
                                color: (theme) => theme.palette.text.primary,
                            }}>
                                ที่มา : {warning_detail?.information_source_name || "-"}
                            </Typography>
                            <div className='flex justify-start items-center gap-2'>
                                <Avatar src={warning_detail?.editorial?.media_file ? `${baseApi}/${warning_detail?.editorial?.media_file?.media_file_path}${warning_detail?.editorial?.media_file?.media_file_name}` : undefined} sx={{ width: 45, height: 45 }} alt="Remy Sharp" /> :
                                <Typography sx={{
                                    color: (theme) => theme.palette.text.primary,
                                }}>
                                    {warning_detail?.editorial?.editorial_name || "-"}
                                </Typography>
                            </div>
                        </div> */}
                        <Box sx={{ color: colors.textNormal }}>
                            <Typography fontWeight={500}>หมวดหมู่ : {warning_detail?.content_categorys?.length > 0 ? warning_detail?.content_categorys?.map((list: any) => list?.category?.category_name).join("/") : ""}</Typography>
                        </Box>
                        <TagCustom heading={t("HOME_PAGE_RELATED_TAGS")} data={warning_detail?.content_tags?.map((list: any) => {
                            const params = new URLSearchParams({
                                mode: 'main',
                                tag: list?.tag?.tag_name ?? '',
                            })

                            return {
                                key: `${list?.id_content_tag}`,
                                tag_name: list?.tag?.tag_name,
                                onClick: () => navigate(`${routeName.main.pressRelease}?${params.toString()}`)
                            }
                        })} />


                        {/* COMMENT */}
                        {/* <section className='col-span-12 pt-4 md:pt-10 '>
                            <article className='flex justify-start gap-4 items-center'>
                                <Typography sx={{
                                    color: (theme) => theme.palette.text.primary,
                                }} variant='h5'>
                                    ความคิดเห็น
                                </Typography>
                                <Typography sx={{
                                    color: (theme) => theme.palette.text.primary,
                                }}>{comment.length} รายการ</Typography>
                            </article>
                            <article className='grid grid-cols-12 gap-4 pt-6'>
                                {comment?.filter((x, i) => is_show_all_comment ? x : i === 0).map((list, i) => {
                                    const full_name = `${list?.user_name} ${list?.user_last_name}`;
                                    const image_url = list?.file_path ? `${baseApi}/${list?.file_path}${list?.file_name}` : undefined
                                    return (
                                        <div data-aos="fade-right"
                                            data-aos-offset="100"
                                            data-aos-easing="ease" className='flex col-span-12 justify-start items-center gap-4' key={i}>
                                            <span>
                                                <Avatar src={image_url} />
                                            </span>
                                            <span className='flex flex-col gap-2'>
                                                <Typography>
                                                    {full_name}
                                                </Typography>
                                                <Typography variant='h6'>
                                                    {list?.content_comment || "-"}
                                                </Typography>
                                            </span>
                                        </div>
                                    )
                                })}
                                {comment?.length > 1 && (
                                    <div className='col-span-12 flex justify-end items-center'>
                                        <Button
                                            onClick={() => set_is_show_all_comment(prev => !prev)}
                                            startIcon={<KeyboardArrowDownIcon sx={{
                                                rotate: is_show_all_comment ? "180deg" : 0
                                            }} />}>
                                            {is_show_all_comment ? "ซ่อน" : "อ่านทั้งหมด"}
                                        </Button>
                                    </div>
                                )}
                            </article>
                        </section> */}
                        {/* <section className='col-span-12 w-full pt-4 md:pt-10 '>
                            <Typography sx={{
                                color: (theme) => theme.palette.text.primary,
                            }} variant='h5'>
                                {t("HOME_PAGE_FEATURED_NEWS")}
                            </Typography>
                            <Box component={'article'} sx={{
                                gridTemplateColumns: "repeat(auto-fill, minmax(389px, 1fr))",
                                [theme.breakpoints.down('md')]: {
                                    gridTemplateColumns: "repeat(auto-fill, minmax(289px, 1fr))",
                                },
                                display: 'grid',
                                gap: 4,
                                overflow: 'hidden'

                            }}>
                                {content_recommend?.map((list, index) => {
                                    // console.log(list, 'list')
                                    const content_path_recommend: string = `${baseApi_content}/warning-news/${list?.content_no}`
                                    return (
                                        <BoxContent
                                            key={`${list?.id_content}-${index}`}
                                            className='hover:scale-105 transition-all'
                                            source_image={list?.media_file ? `${baseApi}/${list?.media_file_path}/${list?.media_file_name}` : ImageContent.noImage}
                                            topic={list?.content_name}
                                            date_between
                                            onClick={() => navigate(routeName.main.pressReleaseDetail.replace(":id_content", list?.id_content))}
                                            sx={() => ({
                                                maxWidth: 389,
                                            })}
                                            allow_flag
                                            count={{
                                                onLikeClick: () => likeContent(list?.id_content, +list?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (_, id, type) => {
                                                    set_content_recommend((prev) => prev?.map((sp) => {
                                                        return id === list?.id_content ? {
                                                            ...sp,
                                                            like_count: type === 'LIKE' ? sp?.like_count + 1 : sp?.like_count - 1,
                                                            is_like: type === 'LIKE' ? true : false
                                                        } : sp
                                                    }))
                                                }),
                                                like: +list?.total_like || 0,
                                                like_checked: +list?.is_like ? true : false,
                                                shared: +list?.total_shared || 0,
                                                view: +list?.total_view || 0,
                                                onSharedClick: {
                                                    facebookClick: () => {
                                                        likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                            set_content_recommend(prev => prev.map((sp) => {
                                                                return sp?.id_content === id ? {
                                                                    ...sp,
                                                                    total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                } : sp
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                        shareToFacebook(content_path_recommend)
                                                    },
                                                    lineClick: () => {
                                                        likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                            set_content_recommend(prev => prev.map((sp) => {
                                                                return sp?.id_content === id ? {
                                                                    ...sp,
                                                                    total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                } : sp
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.LINE)
                                                        shareToLine(content_path_recommend, list?.content_name);
                                                    },
                                                    xClick: () => {
                                                        likeContent(list?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                            set_content_recommend(prev => prev.map((sp) => {
                                                                return sp?.id_content === id ? {
                                                                    ...sp,
                                                                    total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                } : sp
                                                            }))
                                                        }, SOCIAL_MEDIA_TYPE.X)
                                                        shareToX(content_path_recommend, list?.content_name)
                                                    },
                                                }
                                            }}
                                            mode={list?.type_measures}
                                            date={list?.content_start_date}
                                            is_hot
                                            fitContent
                                            imageHeight={'226px'}
                                        />
                                    )
                                })}
                            </Box>
                        </section> */}

                        <ContainerButton
                            sxContainer={{ my: 10 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    key: "BACK",
                                    buttonProps: {
                                        sx: {
                                            borderRadius: "48px"
                                        },
                                        onClick: () => {
                                            if (window.history.length > 1) {
                                                navigate(-1);
                                            } else {
                                                navigate(routeName.main.pressRelease);
                                            }
                                        },
                                    },
                                    // borderRadius: 48,
                                    label: "ย้อนกลับ",
                                    type: "BACK"
                                }
                            ]}
                        />
                    </article>
                    {banner_type === BANNER_TYPE.TYPE_THREE && (
                        <article className={clsx('relative col-span-4 h-full max-h-fit overflow-hidden', {
                        })}>
                            <Box className="flex flex-col my-4 md:flex-row justify-between items-center">
                                <span>
                                    <Typography variant='h6'>รายการแนะนำ/ยอดนิยม</Typography>
                                </span>
                                <span>
                                    <Button onClick={() => navigate(routeName.main.pressRelease)} sx={{ color: "#9E640E" }} endIcon={<ArrowCircleRightIcon />}>ดูทั้งหมด</Button>
                                </span>
                            </Box>
                            <Box className="h-full w-full flex flex-col gap-4">
                                {content_recommend?.map((list, index) => {
                                    const id = `key_${index}`;
                                    // console.log(list, 'list')
                                    return (
                                        <div key={id} className='w-full flex relative h-full min-h-[294px] max-h-[294px] border-4 border-white shadow-md'>
                                            <Box className="w-full max-w-[150px] min-w-[150px] h-full">
                                                <PreviewImage
                                                    image_url={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                    disable_show={false}
                                                    disabled_max_width
                                                    render_image={
                                                        <img className='object-cover h-full' src={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`} alt="image" />
                                                    }
                                                />
                                            </Box>
                                            <Box className="flex flex-col justify-between items-start gap-4 py-[14px] px-2  flex-1">
                                                <Box>
                                                    <Typography fontWeight={800} sx={{ fontSize: "1.2em" }}>{list?.content_name || "-"}</Typography>
                                                </Box>
                                                <Box>
                                                    <HtmlRenderer maxLines={2} html={list?.content_desc || ""} />
                                                    <Typography sx={{ fontSize: "14px", color: "#828282" }} variant='h6'>
                                                        หมวดหมู่ : {list?.category_names || "-"}
                                                    </Typography>
                                                    <OptionContent
                                                        date={list?.content_start_date}
                                                        count={{
                                                            like: +list?.total_like || 0,
                                                            like_checked: !!list?.is_like,
                                                            shared: +list?.total_shared || 0,
                                                            view: +list?.view_total || 0,
                                                            onLikeClick: () => likeContent(list?.id_content, +list?.is_like ? 'DISLIKE' : 'LIKE', 'CONTENT', (st, id, type) => {
                                                                set_content_recommend((prev: any[]) => prev.map((sp) => {
                                                                    return sp?.id_content === id ? {
                                                                        ...sp,
                                                                        total_like: type === 'LIKE' ? +sp?.total_like + 1 : +sp?.total_like - 1,
                                                                        is_like: type === 'LIKE' ? true : false
                                                                    } : sp
                                                                }))
                                                            }),
                                                            onSharedClick: {
                                                                facebookClick: () => {
                                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                                        set_content_recommend((prev: any[]) => prev.map((sp) => {
                                                                            return sp?.id_content === id ? {
                                                                                ...sp,
                                                                                total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                            } : sp
                                                                        }))
                                                                    }, SOCIAL_MEDIA_TYPE.FACEBOOK)
                                                                    shareToFacebook(content_path)
                                                                },
                                                                lineClick: () => {
                                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                                        set_content_recommend((prev: any[]) => prev.map((sp) => {
                                                                            return sp?.id_content === id ? {
                                                                                ...sp,
                                                                                total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                            } : sp
                                                                        }))
                                                                    }, SOCIAL_MEDIA_TYPE.LINE)
                                                                    shareToLine(content_path, warning_detail?.content_name);
                                                                },
                                                                xClick: () => {
                                                                    likeContent(warning_detail?.id_content, 'SHARED', 'CONTENT', (st, id) => {
                                                                        set_content_recommend((prev: any[]) => prev.map((sp) => {
                                                                            return sp?.id_content === id ? {
                                                                                ...sp,
                                                                                total_shared: st ? +sp?.total_shared + 1 : +sp?.total_shared
                                                                            } : sp
                                                                        }))
                                                                    }, SOCIAL_MEDIA_TYPE.X)
                                                                    shareToX(content_path, warning_detail?.content_name)
                                                                },
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                        </div>
                                    )
                                })}
                                {/* <Swiper
                                    direction={matches ? 'horizontal' : 'vertical'}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    navigation={{
                                        nextEl: nextRef.current,
                                        prevEl: preRef.current,
                                    }}
                                    spaceBetween={20}
                                    slidesPerView={matches ? 1 : 4}
                                    modules={[Pagination, Navigation]}
                                    className="mySwiper cursor-grab"
                                    onInit={handleInit}
                                >
                                    {media_file?.map((list, index) => {
                                        const id = `key_${index}`;
                                        return (
                                            <SwiperSlide style={{ height: 500 }} className="relative" key={id}>
                                                <div className='w-full relative h-[500px] border-4 border-white shadow-md'>
                                                    <PreviewImage
                                                        image_url={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                        disable_show={false}
                                                        disabled_max_width
                                                        render_image={
                                                            <img className='object-cover' src={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`} alt="image" />
                                                        }
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })}
                                </Swiper> */}
                            </Box>
                        </article>
                    )}
                </section>


                {/* <Snackbar
                    open={open_alert}
                    autoHideDuration={5000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // <<< ตรงนี้
                >
                    <Alert
                        onClose={handleClose}
                        severity="success"
                        sx={{ width: '100%' }}
                        variant="filled"
                    >
                        แสดงความคิดเห็นเรียบร้อย
                    </Alert>
                </Snackbar> */}
            </Box >
        </>
    )
}

export default PressReleaseDetail
